<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Precios</h3>
              </div>
            </div>
          </template>
          <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-4"
            >
              <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Datos por página"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item.value"
                    :label="item.descripcion"
                    :value="Number(item.value)"
                  >
                  </el-option>
              </el-select>
              <div class="text-right">
                <a href="/templates/Precios.xlsx" class="btn btn-default hover-apolo" download alt="Descargar template de precios"><i class="fas fa-file-download"></i>  Descargar template de precios</a>
              </div>
            </div>
          <!-- CARGA DE ARCHIVO -->
          <div class="d-flex">
            <div class="col-lg-8 col-sm-12 mb-2">
              <form class="new-event--form" @submit.prevent="addPrecio">
                <div style="display:inline-block; width: 60%;">
                  <label class="form-control-label">Seleccione archivo de precios</label>

                  <div class="custom-file"> 
                    <base-input type="file" inputClasses="custom-file-input" id="precios" lang="es" v-model="precio.precios" @change="filesChange"></base-input>
                    <label class="custom-file-label" for="precios">{{ archivoSeleccionado }}</label>
                  </div>                  
                </div>                

                <div class="ml-2" style="display:inline-block">
                  <base-button class="hover-apolo" type="default" icon @click="addPrecio">
                    <span class="btn-inner--icon"
                      ><i class="fas fa-file-import"></i></span>
                    <span class="btn-inner--text">Importar Precios</span>
                  </base-button>
                </div>
              </form>
              <br>
              <div class="row">
                {{ errores }}
              </div>
            </div>
            <div class="col-lg-4 col-sm-12 m-auto pt-4 text-right">
              <base-button class="hover-apolo" type="default" icon @click="exportarPrecio">
                <span class="btn-inner--icon"
                  ><i class="fas fa-file-export"></i></span>
                <span class="btn-inner--text">Exportar tabla de Precios</span>
              </base-button>
            </div>
          </div>
          <div>
            <div class="col-lg-9 col-sm-12 mb-2">
              <validation-error :errors="apiValidationErrors.precios" />
            </div>
            <div class="col-lg-9 col-sm-12 mb-2">
              <validation-errors :errors="apiValidationErrors.filas" />
            </div>
          </div>  
          <div>
            <pulse-loader class="text-center" v-if="loadingSpinner" :loading="loadingSpinner" :color="color" :size="size"></pulse-loader>
            <el-table
              class="table-responsive align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="precios"
              @sort-change="sortChange"
            >
              <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
              </div>

              <div slot="empty" v-if="precios">
                Sin datos disponibles
              </div>
  
              <el-table-column label="Fecha Inicio">
                <div slot-scope="{ row }">
                  <span v-if="row.fecha_inicio">{{row.fecha_inicio | moment('DD-MM-YYYY')}}</span>
                  <span v-else>Sin Fecha</span>
                </div>
              </el-table-column>
              <el-table-column label="Fecha Fin">
                <div slot-scope="{ row }">
                  <span v-if="row.fecha_fin">{{row.fecha_fin | moment('DD-MM-YYYY')}}</span>
                  <span v-else>Sin Fecha</span>
                </div>
              </el-table-column>
              <el-table-column label="Tramo Origen" prop="terminal_origen" />
              <el-table-column label="Tramo Destino" prop="terminal_destino" />
              <el-table-column label="Categoria" prop="categoria" />
              <el-table-column label="Precio Taquilla">
                <div slot-scope="{ row }">
                  <span>${{row.precio_taquilla}}</span>
                </div>
              </el-table-column>
              <el-table-column label="Precio En Linea">
                <div slot-scope="{ row }">
                  <span>${{row.precio_en_linea}}</span>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center flex-wrap"
          >
            <base-pagination
              class="pagination-no-border justify-content-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </div>
        </card>
      </div>      
    </div>
  </template>
  <script>
  import { BasePagination, Modal } from "@/components/";
  import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
    Select,
    Option,
    RadioButton,
    Button,
  } from "element-ui";
  import swal from "sweetalert2";
  import "sweetalert2/dist/sweetalert2.css";
  import ValidationError from "@/components/ValidationError.vue";
  import ValidationErrors from "@/views/Gestion/Precios/ValidationErrors.vue";
  import formMixin from "@/mixins/form-mixin";
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
  
  export default {
    layout: "DashboardLayout",
  
    components: {
      PulseLoader,
      ValidationError,
      ValidationErrors,
      Modal,
      BasePagination,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      [Button.name]: Button,
    },

    mixins: [formMixin],
  
    data() {
      return {
        loadingSpinner: false,
        color: '#0068a0',
        size: '45px',
        precios: [],
        selectedRows: [],
        query: null,
  
        sort: "created_at",
  
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [{value:'5', descripcion: '5 precios por página'},
          {value:'10', descripcion: '10 precios por página'},
          {value:'25', descripcion: '25 precios por página'},
          {value:'50', descripcion: '50 precios por página'}],
        },
        total: 0,
        loading: true,
        showAddModal: false,
        showEditModal: false,
        files: null,
        errores: null,
        archivoSeleccionado: 'Selecciona un archivo...',
        precio: {
          type: "precios",
          fecha_inicio: null,
          fecha_fin: null,
          terminal_origen: null,
          terminal_destino: null,
          categoria_asiento: null,
          precio_taquilla: null,
          precio_en_linea: null
        }
      };
    },

    created(){
      //console.log(this.me);
    },
  
    computed: {
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
  
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
    },
  
    watch: {
      query: {
        handler: "getListDebounced",
        immediate: true,
      },
      pagination: {
        handler: "getList",
        immediate: false,
        deep: true,
      },
    },

    mounted(){
      //const date = new Date();
      //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    },
  
    methods: {
      getListDebounced: _.debounce(function () {
        this.getList();
      }, 300),

      filesChange(event) {
        if( typeof event.target.files[0] !== 'undefined'){
          this.files = event.target.files[0];
          this.archivoSeleccionado = this.files.name;
        }    
        else{
          this.archivoSeleccionado = 'Selecciona un archivo...';
        }            
        this.resetApiValidation();          
      },
  
      async getList() {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { nombre: this.query } : {}),
            ...(this.query ? { abreviatura: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };
  
        await this.$store.dispatch("precios/list", params).then(() => {
          this.precios = this.$store.getters["precios/list"];
          this.total = this.$store.getters["precios/listTotal"];
        });
        this.loading = false;
      },

      /*closeModal() {
        if(this.showAddModal == true){
          this.showAddModal = false;
        }else{
          this.showEditModal = false;
        }
        this.resetApiValidation();
        this.precio.nombre = null;
        this.precio.abreviatura = null;
      },*/

      async addPrecio(){
        this.loadingSpinner = true;
        try {
          let formData = new FormData();
          formData.append('precios', this.files);
          await this.$store.dispatch("precios/add", formData)
          this.loadingSpinner = false;
          this.$notify({
                type: "success",
                message: "Precio creado satisfactoriamente.",
                duration: -1
              });
          //this.getList();
          this.$router.go(this.$router.currentRoute)
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: "Se encontraron errores de validación.",
                  duration: -1
                  //message: error.response.data.errors[0].detail,
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.loadingSpinner = false;
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },

      exportarPreciosTest(){
        //var route = this.route('export.excelAvances')+'?periods='+this.form.years_periods+'&population='+this.form.population_id+'&objectives='+this.form.objectives_id+'&institution='+this.form.institution_id+'&topics='+this.form.topics_id+'&right='+this.form.right_id;
        //window.open(route, '_target');
        
      },

      async exportarPrecio(){
        this.loading = true;
        /*let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { nombre: this.query } : {}),
            ...(this.query ? { abreviatura: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
        };*/
  
        await this.$store.dispatch("precios/exportar").then(() => {
          //this.precios = this.$store.getters["precios/list"];
          //this.total = this.$store.getters["precios/listTotal"];
        });
        this.loading = false;
      },

      /*
      editPrecio(row) {
        this.resetApiValidation();
        this.showEditModal = true;
        this.precio.nombre = row.nombre;
        this.precio.abreviatura = row.abreviatura;
        this.precio.id = row.id;
      },

      async updatePrecio() {
        try{
          await this.$store.dispatch("precios/update", this.precio);
          this.$notify({
            type: "success",
            message: "Pecio actualizado satisfactoriamente."
          });
          this.getList();
          this.closeModal();
        } catch (error) {
          this.$notify({
            type: "danger",
            message: "Oops, ha ocurrido un problema!"
          });
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
      },
  
      async deletePrecio(id) {
        const confirmation = await swal.fire({
          title: `¿Desea eliminar este precio?`,
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonClass: "btn btn-lg btn-default hover-apolo",
          cancelButtonClass: "btn btn-lg btn-secondary hover-apolo",
        });
  
        try {
          if (confirmation.value === true) {
            await this.$store.dispatch("precios/destroy", id);
            await this.getList();
            this.$notify({
              type: "success",
              message: "Precio eliminado satisfactoriamente.",
            });
          }
        } catch (error) {
          if (error.response.data.errors[0]) {
            this.$notify({
              type: "danger",
              message: "Este precio esta asociada al menos a una terminal.",
            });
          } else {
            this.$notify({
              type: "danger",
              message: "Oops, ha ocurrido un problema!",
            });
          }
        }
      },
      */

      sortChange({ prop, order }) {
        if (order === "descending") {
          this.sort = `-${prop}`;
        } else {
          this.sort = `${prop}`;
        }
        this.getList();
      },
    },
  };
  </script>
  <style>
    .el-table .cell {
      word-break: break-word;
    }
    .argon-error {
      position: inherit;
      bottom: 0px !important;
      color: #fb6340;
    }
 </style>